module.exports = __webpack_public_path__ + "img/618093582d97baf3267c83e39f56e176.png";